import ContactsIcon from "assets/menu-icons/ContactsIcon";

const contacts = {
  id: 'contacts',
  type: 'group',
  children: [{
    id: 'contacts',
    title: 'Контакты', 
    type: 'item',
    url: '/contacts',
    icon: ContactsIcon,
    breadcrumbs: false
  }]
}

export default contacts;